import { useEffect } from "react"
import { useLocation } from "@tanstack/react-router"

export const DEFAULT_SETTINGS_RETURN_PATH = "/threads"

let lastAppPath: string | null = null

export function rememberAppPath(path: string) {
	if (path.startsWith("/settings")) return
	lastAppPath = path
}

/** Where the settings back button goes: the last app page, or the inbox on a cold load. */
export function settingsReturnPath(): string {
	return lastAppPath ?? DEFAULT_SETTINGS_RETURN_PATH
}

export function useRememberAppPath() {
	const { pathname, searchStr } = useLocation()
	useEffect(() => {
		rememberAppPath(pathname + searchStr)
	}, [pathname, searchStr])
}
